import React, { Component } from 'react';
import {
  View,
  Text,
  ScrollView,
  TouchableHighlight,
  TextInput,
  Platform,
  Image,
  Dimensions,
  Alert,
} from 'react-native';
import {StyleContext} from '../styleC';
import strings from '../strings';
import MavButton from './mavButton';
import firebase from './firebase';
import { getAuth } from "firebase/auth";
import { getDatabase, ref, set, update, remove, get, onValue, child, orderByChild, orderByValue, limitToFirst, startAt, endAt, query} from "firebase/database";
import MavAlert from './mavAlert';
import MavSelector from './mavSelector';
import moneyList from '../moneyList';
import Modal from './modal';
import MavNavigationMinimize from './mavNavigationMinimize';
import MavInfoBubble from './mavInfoBubble';
import TextPresentation from './textPresentation';
import MavMiniButton from './mavMiniButton';
import RaceTrajetInfo from './raceTrajetInfo';


const timer = require('react-native-timer');
export default class account extends Component {
  constructor(props) {
    super(props);

    var params=(this.props.route!=undefined)?this.props.route.params:this.props.params; 
    var infoMoney=this.findMoney();
    this.state = {
        kilometerMax:"",
        money:infoMoney,
        moneySelected:infoMoney,
        durationMin:0,
        providerFixeCommission:(params!=undefined && params.providerFixeCommission!=undefined)?params.providerFixeCommission:false,
        carList:{},
        carListSave:{},
        carInfo:{},
        extraEUMode:false, 
        vipMode:false,
        luggageOption:false,
        multipleCarProvision:false,
        multipleCarProvisionOld:false,
        co2onBill:(params!=undefined && params.co2onBill!=undefined)?params.co2onBill:false,
        typeZone:[], 
    };
  }


  findMoney(value){
    if(value==undefined) value="eu";
    var final="";
    var i;
    for(i=0;i<moneyList.length;i++){
      if(final==""){
        console.log(moneyList[i])
        if(moneyList[i].id==value) final=moneyList[i];
      }
    }
    return final
  }



  onPricePlace = (data,i) => {
    var typeZone=JSON.parse(JSON.stringify(this.state.typeZone)); 
    typeZone[i].name=data.description;
    typeZone[i].latitude=data.coordinates.latitude
    typeZone[i].longitude=data.coordinates.longitude
    this.setState({typeZone:typeZone})
     this.changeRadius(i)
}

  changeAllPrice(value, idZone){
    console.log("changeAllPrice lancée")
      var car=this.state.carList; 
      var money=this.state.money.symbole;

      if(idZone!=undefined) {
        car=(this.state.typeZone[idZone].price!=undefined)?this.state.typeZone[idZone].price:{};
        if(this.state.typeZone[idZone].money!=undefined) money=this.state.typeZone[idZone].money.symbole;
      }

      
      var carArray=Object.keys(car)
      var type=["1","2","3","4","5","more","provCom"];
      var i;
      for(i=0;i<carArray.length;i++){
          for(j=0;j<type.length;j++){
            if(car[carArray[i]][type[j]]!=undefined){
              car[carArray[i]][type[j]]=car[carArray[i]][type[j]].replace(money,'')
              car[carArray[i]][type[j]]=((value.position=="left")?(value.symbole+" "):"")+car[carArray[i]][type[j]]+((value.position=="right")?(value.symbole):"")
            }
            
              
          }  
      }
      
      
      if(idZone!=undefined){
        var typeZone=JSON.parse(JSON.stringify(this.state.typeZone)); 
        typeZone[idZone].price=car;
        typeZone[idZone].money=value
        this.setState({typeZone:typeZone})
      }
      else this.setState({money:value,carList:car})
  }


  changePrice(rowData,value,type,indexR){

    if(indexR==undefined){
          var car=this.state.carList;    
          car[rowData][type]=value.toString().replace(",",'.')
          car[rowData][type]=value.toString().replace(this.state.moneySelected.symbole,'')
          console.log(car)
          this.setState({ carList:car });

          timer.setTimeout("changePrice"+type, () => {
              var test=this.state.carList[rowData][type].indexOf(this.state.money.symbole);
              if(test==-1 && this.state.carList[rowData][type]!="") {
                var car=this.state.carList;
                car[rowData][type]=((this.state.moneySelected.position=="left")?(this.state.moneySelected.symbole+" "):"")+car[rowData][type]+((this.state.moneySelected.position=="right")?(this.state.moneySelected.symbole):"")
                this.setState({carList:car}); 
              }
          }, 1000);
        }

    else {

          var car=JSON.parse(JSON.stringify(this.state.typeZone));
          car[indexR].price[rowData][type]=value.toString().replace(",",'.')
          car[indexR].price[rowData][type]=value.toString().replace(  ((this.state.typeZone[indexR].money!=undefined)?this.state.typeZone[indexR].money:this.state.money).symbole  ,'') 
          this.setState({typeZone:car}) 

          timer.setTimeout("changePrice"+type, () => {
              var test=this.state.typeZone[indexR].price[rowData][type].indexOf(((this.state.typeZone[indexR].money!=undefined)?this.state.typeZone[indexR].money:this.state.money).symbole); 
              if(test==-1 && this.state.typeZone[indexR].price[rowData][type]!="") {
                var car=JSON.parse(JSON.stringify(this.state.typeZone));
                car[indexR].price[rowData][type]=((((this.state.typeZone[indexR].money!=undefined)?this.state.typeZone[indexR].money:this.state.money).position=="left")?(((this.state.typeZone[indexR].money!=undefined)?this.state.typeZone[indexR].money:this.state.money).symbole+" "):"")+car[indexR].price[rowData][type]+((((this.state.typeZone[indexR].money!=undefined)?this.state.typeZone[indexR].money:this.state.money).position=="right")?(((this.state.typeZone[indexR].money!=undefined)?this.state.typeZone[indexR].money:this.state.money).symbole):"")
                this.setState({typeZone:car}) 
              }
          }, 1000);




    }

    

}

changeKm(value,radius){

  timer.setTimeout(generateUUID(), () => {
    var value=(radius=="radius")?this.state.typeZone[this.state.typeZoneSelected].radius:this.state.kilometerMax
        var test=value.indexOf("km");

        if(test==-1 && value!="" && isNaN(parseFloat(value))==false ) {
          value+="km";
          if(radius=="radius"){
            var typeZone=JSON.parse(JSON.stringify(this.state.typeZone)); 
            typeZone[this.state.typeZoneSelected].radius=value
            this.setState({typeZone:typeZone})
          }
          else this.setState({ kilometerMax:value });
        } 
    }, 1000);
    value=value.toString().replace("km",'')
    value=value.toString().replace(",",'.')
    if(radius=="radius"){
      var typeZone=JSON.parse(JSON.stringify(this.state.typeZone)); 
      typeZone[this.state.typeZoneSelected].radius=value
      this.setState({typeZone:typeZone})
    }
    else this.setState({ kilometerMax:value });

}

testCar(car, money){

  var params=(this.props.route!=undefined)?this.props.route.params:this.props.params; 

  var result={
    1:parseFloat(car[1].toString().replace(money.symbole,'')),
    2:parseFloat(car[2].toString().replace(money.symbole,'')),
    3:parseFloat(car[3].toString().replace(money.symbole,'')),
    4:parseFloat(car[4].toString().replace(money.symbole,'')),
    5:parseFloat(car[5].toString().replace(money.symbole,'')),
    more:parseFloat(car.more.toString().replace(money.symbole,'')),
    provCom:(this.state.providerFixeCommission==true && car.provCom!=undefined)?parseFloat(car.provCom.toString().replace(money.symbole,'')):null,
    passagers:car.passagers,
    name:car.name.trim(),
    co2:( (typeof car.co2 !== 'undefined')  && (car.co2.toString().length>0 || car.co2.toString()=="0" ) )?car.co2:null,
  }

  if(params!=undefined && params.luggageOption===true){result.luggageMax=(car.luggageMax!=undefined)?car.luggageMax:1}
  if(params!=undefined && params.extraEUMode===true){result.moneyID=money.id}

  if(params!=undefined && params.vipMode===true){
      var target=car.target;
      if(target==undefined) target=[true, true, true];
      result.target={ standard:target[0], vip:target[1], pro:target[2]  }
    }

  if(result.name=="" || isNaN(result[1]) || isNaN(result[2]) || isNaN(result[3]) || isNaN(result[4]) || isNaN(result[5]) || isNaN(result.more) ) result.error=strings.pricingErrorCar+" "+result.name;

  return result; 

}

confirmModification(){
      var error=false;
      var sendToFirebase=new Object;
      var params=(this.props.route!=undefined)?this.props.route.params:this.props.params; 
      var carListArray=Object.keys(this.state.carList);
      var result;
      var i,j; 

      for(i=0;i<carListArray.length;i++){
        if(error==false){
            result=this.testCar(this.state.carList[carListArray[i]], this.state.money)
            if(result.error!=undefined) error=result.error;
            else sendToFirebase[carListArray[i]]=result;
        }
      }
      if(this.state.typeZone.length>0 && error==false){
        var typeZoneList=[];

        /*pour chaque zone, je teste tout les prix*/
        for(j=0;j<this.state.typeZone.length;j++){
          console.log("test zone "+this.state.typeZone[j].name)
          
          var priceOftheZone;
          
            if(this.state.typeZone[j].name==undefined || this.state.typeZone[j].name=="" || this.state.typeZone[j].radius==undefined || this.state.typeZone[j].radius=="")  error=strings.thanksAllItems+" "+strings.forTheZone.toLowerCase()+" "+this.state.typeZone[j].name; 
            else if(this.state.typeZone[j].price==undefined || Object.keys(this.state.typeZone[j].price).length==0) error=strings.noDefinedPrice+" "+strings.forTheZone.toLowerCase()+" "+this.state.typeZone[j].name; 
            else {

              carListArray=Object.keys(this.state.typeZone[j].price);
              priceOftheZone={};
              for(i=0;i<carListArray.length;i++){
                if(error==false){
                    result=this.testCar(this.state.typeZone[j].price[carListArray[i]], ((this.state.typeZone[j].money!=undefined)?this.state.typeZone[j].money:this.state.money))
                    if(result.error!=undefined) error=result.error+" "+strings.forTheZone.toLowerCase()+" "+this.state.typeZone[j].name; 
                    else priceOftheZone[carListArray[i]]=result;
                }
              }

              var sendRI={name:this.state.typeZone[j].name, latitude:this.state.typeZone[j].latitude, longitude:this.state.typeZone[j].longitude,radius:parseFloat(this.state.typeZone[j].radius), price:priceOftheZone}
              if(this.state.typeZone[j].money!=undefined) sendRI.moneyID=this.state.typeZone[j].money.id
              typeZoneList.push(sendRI)
              
            }


        }

        if(error==false) sendToFirebase.typeZone=typeZoneList; 

      }

      if(error!=false) this.alert.onAlert({title:error}); 
      else {
      var kilometerMax=(this.state.kilometerMax!="" && isNaN(parseFloat(this.state.kilometerMax))==false)?parseFloat(this.state.kilometerMax):null;

      console.log(JSON.stringify(sendToFirebase))

      const fireInfo={} 
      fireInfo["/pricingProvision"]=sendToFirebase; 
      fireInfo["/settings/kilometerMax"]=kilometerMax;
      fireInfo["/settings/durationMin"]=this.state.durationMin; 
      fireInfo["/settings/multipleCarProvision"]=(this.state.multipleCarProvision==true)?true:null;

      update(ref(getDatabase(firebase)), fireInfo)
      
      if(Platform.OS=="web") this.props.params.goBack();
      else this.props.navigation.goBack()
      

    }
}

  

  componentDidMount() {
   var params=(this.props.route!=undefined)?this.props.route.params:this.props.params; 

    if (getAuth(firebase).currentUser!= null && this.state.id!="") {
      get(child(ref(getDatabase(firebase)), '/pricingProvision')).then(value => {
        var val = value.val();
        
        if(val!=null){
        
              var price=Object.keys(val);
              var i,j,k,l,temp, temp2;

              for(i=0;i<price.length;i++){

                if(price[i]=="typeZone"){
                  var typeZoneProv=JSON.parse(JSON.stringify(val[price[i]]));
                  delete val[price[i]]; 
                  for(k=0;k<typeZoneProv.length;k++){
                    var money=this.findMoney();
                      if(typeZoneProv[k].moneyID!=undefined)  {
                        typeZoneProv[k].money=this.findMoney(typeZoneProv[k].moneyID); 
                         money=this.findMoney(typeZoneProv[k].moneyID);
                       }

                      temp2=Object.keys(typeZoneProv[k].price);
                      typeZoneProv[k].radius+="km";
                      for(l=0;l<temp2.length;l++){
                          temp=Object.keys(typeZoneProv[k].price[temp2[l]]);
                          for(j=0;j<temp.length;j++){
                            if(temp[j]!="passagers" && temp[j]!="co2" && temp[j]!="target" && temp[j]!="name" && temp[j]!="luggageMax" && temp[j]!="moneyID" ) typeZoneProv[k].price[temp2[l]][temp[j]]= ((money.position=="left")?(money.symbole+" "):"")+typeZoneProv[k].price[temp2[l]][temp[j]]+((money.position=="right")?(money.symbole):"")
                          }
                          
                      }

                      

                      

                  }
                  



                  this.setState({typeZone:typeZoneProv, typeZoneSave: typeZoneProv});
                  

                }
                else{ 
                    temp=Object.keys(val[price[i]]);

                    if(i==0){
                          var infoMoney=this.state.money
                          if(params!=undefined && params.extraEUMode===true){
                            infoMoney=this.findMoney((val[price[i]].moneyID!=undefined)?val[price[i]].moneyID:"eu"); 
                            this.setState({money:infoMoney})
                          }
                      }

                    for(j=0;j<temp.length;j++){
                        if(temp[j]!="passagers" && temp[j]!="co2" && temp[j]!="target" && temp[j]!="name" && temp[j]!="luggageMax" && temp[j]!="moneyID" ) val[price[i]][temp[j]]= ((infoMoney.position=="left")?(infoMoney.symbole+" "):"")+val[price[i]][temp[j]]+((infoMoney.position=="right")?(infoMoney.symbole):"")
                     
                    }

                  if(params!=undefined){this.setState({extraEUMode: (params.extraEUMode==true)?true:false, vipMode:(params.vipMode==true)?true:false,  luggageOption:(params.luggageOption==true)?true:false  }) }
                  if(val[price[i]].passagers==undefined) val[price[i]].passagers=1;

              }


            }        
              this.setState({carList:val, carListSave:val})
      
      }
  
        

      });
      get(child(ref(getDatabase(firebase)), '/settings')).then(value => {

        var val=value.val();
        if(val!=null){
            var st={}
            if(val.kilometerMax!=undefined) st.kilometerMax=val.kilometerMax+"km";
            if(val.durationMin!=undefined) st.durationMin=val.durationMin;
            if(val.multipleCarProvision!=undefined) st.multipleCarProvision=val.multipleCarProvision;

            this.setState(st)
        } 
      })


    }
    
  }

    viewTarget = (rowData, indexR) => {

      if(indexR==undefined){
          var list=[{text:strings.standard, selected:(this.state.carList[rowData].target==undefined || this.state.carList[rowData].target.standard!=false)?true:false },{text:strings.vip, selected:(this.state.carList[rowData].target==undefined || this.state.carList[rowData].target.vip!=false)?true:false },{text:strings.pro, selected:(this.state.carList[rowData].target==undefined || this.state.carList[rowData].target.pro!=false)?true:false }];
          this.alert.onAlert({title:strings.target, subTitle:strings.selectUsersPricing, items:list,multiSelected:true, buttons:[{text: strings.validate,onPress: (list) => {
              var opt=this.state.carList; 
              opt[rowData].target={standard:(list[0].selected==true)?true:false, vip:(list[1].selected==true)?true:false, pro:(list[2].selected==true)?true:false,}          
              this.setState({carList:opt})      

          }},{text: strings.cancel, style:"cancel",onPress: () => {}}] })  

           }
    else {
          var list=[{text:strings.standard,  selected:(this.state.typeZone[indexR].price[rowData].target==undefined || this.state.typeZone[indexR].price[rowData].target.standard!=false)?true:false },{text:strings.vip,  selected:(this.state.typeZone[indexR].price[rowData].target==undefined || this.state.typeZone[indexR].price[rowData].target.vip!=false)?true:false },{text:strings.pro, selected:(this.state.typeZone[indexR].price[rowData].target==undefined || this.state.typeZone[indexR].price[rowData].target.pro!=false)?true:false }];
         
          this.alert.onAlert({title:strings.target, subTitle:strings.selectUsersPricing, items:list,multiSelected:true, buttons:[{text: strings.validate,onPress: (list) => {
              var car=JSON.parse(JSON.stringify(this.state.typeZone));
              car[indexR].price[rowData].target={standard:(list[0].selected==true)?true:false, vip:(list[1].selected==true)?true:false, pro:(list[2].selected==true)?true:false,}          
              this.setState({typeZone:car})     

          }},{text: strings.cancel, style:"cancel",onPress: () => {}}] })  
    }

     
  }

  changePassagers(rowData,value,indexR){
    if(indexR==undefined){
          var car=JSON.parse(JSON.stringify(this.state.carList)); 
          var val=(car[rowData].passagers==undefined)?1:car[rowData].passagers;
          val=val+((value==-1)?-1:+1) ;
          if(val<0) val=1;
          car[rowData].passagers=val;
          this.setState({carList:car});
    }
    else {

          var car=JSON.parse(JSON.stringify(this.state.typeZone));
          var val=(car[indexR].price[rowData].passagers==undefined)?1:car[indexR].price[rowData].passagers;
          val=val+((value==-1)?-1:+1) ;
          if(val<0) val=1;
          car[indexR].price[rowData].passagers=val;
          this.setState({typeZone:car}) 
    }
   

  }

  changeCO2(rowData,value, indexR){
     if(indexR==undefined){
        var car=JSON.parse(JSON.stringify(this.state.carList)); 
        car[rowData].co2=(value!="")?parseFloat(value):"";
        if(!isNaN(car[rowData].co2)) this.setState({carList:car});
    }
    else {
          var car=JSON.parse(JSON.stringify(this.state.typeZone));
          car[indexR].price[rowData].co2=(value!="")?parseFloat(value):"";;
          if(!isNaN(car[indexR].price[rowData].co2)) this.setState({typeZone:car}) 
    }
   

  }


  removePrice= (rowData,j, indexR) => {
      if(indexR==undefined){
           this['viewCar_' + j].close();
            var cl={}
            var i;
            var obj=Object.keys(this.state.carList)
            var test;
            for (i=0;i<obj.length;i++){
              test="type"+(i+1);
              if(test!=rowData) cl["type"+(Object.keys(cl).length+1)]=this.state.carList[obj[i]];
            }
             this.setState({carList:cl})
      }

      else {
          this['viewCar_'+indexR+"_" + j].close();

            var cl={}
            var i;
            var obj=Object.keys(this.state.typeZone[indexR].price)
            var test;
            for (i=0;i<obj.length;i++){
              test="type"+(i+1);
              if(test!=rowData) cl["type"+(Object.keys(cl).length+1)]=this.state.typeZone[indexR].price[obj[i]];
            }
            var typeZone=JSON.parse(JSON.stringify(this.state.typeZone)); 
            typeZone[indexR].price=cl;
            this.setState({typeZone:typeZone})



      }
     

    }

      changeBaggage(rowData,value, indexR){
         if(indexR==undefined){
            var car=JSON.parse(JSON.stringify(this.state.carList)); 
            var val=(car[rowData].luggageMax==undefined)?1:car[rowData].luggageMax;
            val=val+value ;
            if(val<1) val=1;
            car[rowData].luggageMax=val;
            this.setState({carList:car});
      }
      else {
            var car=JSON.parse(JSON.stringify(this.state.typeZone));
            var val=(car[indexR].price[rowData].luggageMax==undefined)?1:car[indexR].price[rowData].luggageMax;
            val=val+value ;
            if(val<1) val=1;
            car[indexR].price[rowData].luggageMax=val;
            this.setState({typeZone:car}) 
      }

  }

  closeOtherViewMore= (id,type) => {
  var i;
  if(type=="classic"){
      var objCar=Object.keys(this.state.carList)
      for(i=0;i<objCar.length; i++){
        if(i!=id) this['viewCar_' + i].close();
      }
    }
    else {
      var objCar=Object.keys(this.state.typeZone[type].price)
      for(i=0;i<objCar.length; i++){
        if(i!=id) this['viewCar_'+type+"_" + i].close();
      }

      


    }
}


  changeRadius= (i) => {
    var typeZone=JSON.parse(JSON.stringify(this.state.typeZone)); 
    var radius=typeZone[i].radius
    if(radius==undefined || radius=="") radius='0'
    radius=radius.replace("km","")



    this.alert.onAlert({title:strings.defineRay,subTitle:strings.rayInKM, textInput:{placeholder:"10 km",text:radius,sizeMultiplicator:2,keyboardType:"numeric"},buttons:[
                    {text: strings.validate,onPress: (value) => {
                        if(value=="" || isNaN(parseInt(value))==true) this.changeRadius(i)
                        else {
                          value+="km"; 
                          typeZone[i].radius=value;
                          this.setState({typeZone:typeZone})
                        }
                      
                    }},
                    {text: strings.cancel, style:"cancel",onPress: () => {}}
                    ],})

}



  render() {
    return (
      <StyleContext.Consumer>{style => 
      <ScrollView style={{ marginLeft: 0, marginRight: 0, backgroundColor: style.backgroundColor }}>



      {(Platform.OS=="web" && this.props.params!=undefined && this.props.params.goBack!=undefined) && <MavNavigationMinimize  clickLeft={() => { this.props.params.goBack();  }} left={strings.return} title={ strings.provision } />}


      <MavInfoBubble type={"menu"} icon={(style.mode=="dark")?require('../assets/clock_white.png'):require('../assets/clock_black.png')} title={strings.provision} subTitle={strings.provisionMoreInfo}  style={{marginTop:10,marginBottom:20}} />
      <MavInfoBubble type={"help"} videoLink={"https://www.youtube.com/watch?v=KkHzjpqYyqo"} tutdoLink={"http://www.google.fr"} othders={[{title:strings.customTarifCustomer, link:"ddedede"}]}  style={{marginTop:0,marginBottom:20}} />
            






      <TextPresentation reduceTextSizeOnOff={true} editable={false} text={strings.provisionPriceDefault}  icon={(style.mode=="dark")?require('../assets/clock_white.png'):require('../assets/clock_black.png')} style={{marginTop:10}} textMini={strings.priceProvisionExplication} />

      {this.state.extraEUMode===true  && <TextPresentation style={{marginTop:5,marginLeft:15, marginRight:15}} keyboardType={"numeric"} editable={false} money={this.state.money} text={this.state.money[strings.idLangue]} chooseMoney={true} flagMoney={this.state.money.flag} textExplication={strings.moneySelected} onChangeMoney ={(info)=>{ this.changeAllPrice(info); }}  />}

         {Object.keys(this.state.carList).map((rowData,i) => (


            <TextPresentation explicationChild={strings.priceProvisionAddExplication} ref={viewCar => {this['viewCar_' + i] = viewCar;}} style={{marginLeft:15, marginRight:15}} text={(this.state.carList[rowData].name==undefined)? strings.newCar :((this.state.carList[rowData].name!="")?this.state.carList[rowData].name:strings.noNameCar)} disabledText={true} onOpen={(text)=>{  this.closeOtherViewMore(i,"classic") }}  >


                 <TextPresentation enableError={this.state.disabledChange!=true && this.state.carList[rowData].name==""} enableValidate={this.state.disabledChange!=true && this.state.carList[rowData].name!=undefined && this.state.carList[rowData].name.length>2 }  editable={!this.state.disabledChange} style={{marginTop:5}} text={(this.state.carList[rowData].name!=undefined)?this.state.carList[rowData].name:""} textExplication={strings.priceCarName} placeholder={"ex : Berline"} onChangeText={(text)=>{text=text.replace(/[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/gi, '');  var car=JSON.parse(JSON.stringify(this.state.carList));car[rowData].name=text; this.setState({carList:car}) ;}}/>

                 <TextPresentation reduceTextSizeOnOff={true} editable={false} selectedQuantity={(this.state.carList[rowData].passagers==undefined)?1:this.state.carList[rowData].passagers} text={strings.morePassager+" "+strings.max.toLowerCase()} enableValidate={this.state.disabledChange!=true && this.state.carList[rowData].passagers!=undefined && this.state.carList[rowData].passagers>1}  enableQuestion={this.state.disabledChange!=true && (this.state.carList[rowData].passagers==undefined || this.state.carList[rowData].passagers==1 || this.state.carList[rowData].passagers==0)} onQuestion={(value)=>{this.alert.onAlert({title:strings.warningOnePassager}) }} onChangeQuantity={(value)=>{if(this.state.disabledChange!=true){  this.changePassagers(rowData, value) } }} />
                 {(this.state.luggageOption==true) && <TextPresentation reduceTextSizeOnOff={true}  editable={false} selectedQuantity={(this.state.carList[rowData].luggageMax==undefined)?"1":this.state.carList[rowData].luggageMax} text={strings.baggageMax} enableValidate={this.state.disabledChange!=true}  onChangeQuantity={(value)=>{ if(this.state.disabledChange!=true){  this.changeBaggage(rowData, value) } }} />}
                 {(this.state.co2onBill==true) && <TextPresentation reduceTextSizeOnOff={true}  text={(this.state.carList[rowData].co2!=undefined)?this.state.carList[rowData].co2.toString():""} textExplication={strings.co2+" g/km"} enableValidate={this.state.disabledChange!=true && !isNaN(parseInt(this.state.carList[rowData].co2))}  enableError={this.state.disabledChange!=true && this.state.carList[rowData].co2!=undefined && this.state.carList[rowData].co2!="" && isNaN(parseInt(this.state.carList[rowData].co2)) } placeholder={"ex : 115 g/km"} onChangeText={(text)=>{this.changeCO2(rowData,text)}}/>}

                 <TextPresentation editable={!this.state.disabledChange} keyboardType={"numeric"} text={(this.state.carList[rowData][1]!=undefined)?this.state.carList[rowData][1]:""} textExplication={strings.hour+" n°1 : "} enableValidate={this.state.disabledChange!=true && this.state.carList[rowData][1]!=undefined && !isNaN(parseInt(this.state.carList[rowData][1].replace(this.state.money.symbole,'')))}  enableError={this.state.disabledChange!=true && this.state.carList[rowData][1]!=undefined && isNaN(parseInt(this.state.carList[rowData][1].replace(this.state.money.symbole,''))) }  placeholder={"ex : "+((this.state.money.position=="left")?(this.state.money.symbole+" "):"")+"20"+((this.state.money.position=="right")?(this.state.money.symbole):"")} onChangeText={(text)=>{this.changePrice(rowData, text,"1")}}/>
                 <TextPresentation editable={!this.state.disabledChange} keyboardType={"numeric"} text={(this.state.carList[rowData][2]!=undefined)?this.state.carList[rowData][2]:""} textExplication={strings.hour+" n°2 : "} enableValidate={this.state.disabledChange!=true && this.state.carList[rowData][2]!=undefined && !isNaN(parseInt(this.state.carList[rowData][2].replace(this.state.money.symbole,'')))}  enableError={this.state.disabledChange!=true && this.state.carList[rowData][2]!=undefined && isNaN(parseInt(this.state.carList[rowData][2].replace(this.state.money.symbole,''))) }  placeholder={"ex : "+((this.state.money.position=="left")?(this.state.money.symbole+" "):"")+"20"+((this.state.money.position=="right")?(this.state.money.symbole):"")} onChangeText={(text)=>{this.changePrice(rowData, text,"2")}}/>
                 <TextPresentation editable={!this.state.disabledChange} keyboardType={"numeric"} text={(this.state.carList[rowData][3]!=undefined)?this.state.carList[rowData][3]:""} textExplication={strings.hour+" n°3 : "} enableValidate={this.state.disabledChange!=true && this.state.carList[rowData][3]!=undefined && !isNaN(parseInt(this.state.carList[rowData][3].replace(this.state.money.symbole,'')))}  enableError={this.state.disabledChange!=true && this.state.carList[rowData][3]!=undefined && isNaN(parseInt(this.state.carList[rowData][3].replace(this.state.money.symbole,''))) }  placeholder={"ex : "+((this.state.money.position=="left")?(this.state.money.symbole+" "):"")+"20"+((this.state.money.position=="right")?(this.state.money.symbole):"")} onChangeText={(text)=>{this.changePrice(rowData, text,"3")}}/>
                 <TextPresentation editable={!this.state.disabledChange} keyboardType={"numeric"} text={(this.state.carList[rowData][4]!=undefined)?this.state.carList[rowData][4]:""} textExplication={strings.hour+" n°4 : "} enableValidate={this.state.disabledChange!=true && this.state.carList[rowData][4]!=undefined && !isNaN(parseInt(this.state.carList[rowData][4].replace(this.state.money.symbole,'')))}  enableError={this.state.disabledChange!=true && this.state.carList[rowData][4]!=undefined && isNaN(parseInt(this.state.carList[rowData][4].replace(this.state.money.symbole,''))) }  placeholder={"ex : "+((this.state.money.position=="left")?(this.state.money.symbole+" "):"")+"20"+((this.state.money.position=="right")?(this.state.money.symbole):"")} onChangeText={(text)=>{this.changePrice(rowData, text,"4")}}/>
                 <TextPresentation editable={!this.state.disabledChange} keyboardType={"numeric"} text={(this.state.carList[rowData][5]!=undefined)?this.state.carList[rowData][5]:""} textExplication={strings.hour+" n°5 : "} enableValidate={this.state.disabledChange!=true && this.state.carList[rowData][5]!=undefined && !isNaN(parseInt(this.state.carList[rowData][5].replace(this.state.money.symbole,'')))}  enableError={this.state.disabledChange!=true && this.state.carList[rowData][5]!=undefined && isNaN(parseInt(this.state.carList[rowData][5].replace(this.state.money.symbole,''))) }  placeholder={"ex : "+((this.state.money.position=="left")?(this.state.money.symbole+" "):"")+"20"+((this.state.money.position=="right")?(this.state.money.symbole):"")} onChangeText={(text)=>{this.changePrice(rowData, text,"5")}}/>
                 <TextPresentation editable={!this.state.disabledChange} keyboardType={"numeric"} text={(this.state.carList[rowData].more!=undefined)?this.state.carList[rowData].more:""} textExplication={strings.hourMore} enableValidate={this.state.disabledChange!=true && this.state.carList[rowData].more!=undefined && !isNaN(parseInt(this.state.carList[rowData].more.replace(this.state.money.symbole,'')))}  enableError={this.state.disabledChange!=true && this.state.carList[rowData].more!=undefined && isNaN(parseInt(this.state.carList[rowData].more.replace(this.state.money.symbole,''))) }  placeholder={"ex : "+((this.state.money.position=="left")?(this.state.money.symbole+" "):"")+"20"+((this.state.money.position=="right")?(this.state.money.symbole):"")} onChangeText={(text)=>{this.changePrice(rowData, text,"more")}}/>

                  {(this.state.vipMode===true) && <TextPresentation  textRight={strings.modify} forceClick={()=>{ this.viewTarget(rowData) }} onTextRightClick={()=>{ this.viewTarget(rowData) }}  text={(this.state.carList[rowData].onlyAdmin==true)?(strings.onlyAdmin+"\n"): ((this.state.carList[rowData].target==undefined || (this.state.carList[rowData].target.standard==true && this.state.carList[rowData].target.vip==true && this.state.carList[rowData].target.pro==true))?(strings.all+"\n"):( ((this.state.carList[rowData].target.standard==true)?(strings.standard+"\n"):"")+((this.state.carList[rowData].target.vip==true)?(strings.vip+"\n"):"")+((this.state.carList[rowData].target.pro==true)?(strings.pro+"\n"):"")  ))}  textExplication={strings.target} textExplicationSmall={strings.selectUsersOption} editable={false} />}


                  {(this.state.providerFixeCommission==true) && <TextPresentation keyboardType={"numeric"} text={(this.state.carList[rowData].provCom!=undefined)?this.state.carList[rowData].provCom:""}  textExplication={strings.providerCommission} enableValidate={this.state.disabledChange!=true && this.state.carList[rowData].provCom!=undefined && !isNaN(parseInt(this.state.carList[rowData].provCom.replace(this.state.money.symbole,'')))}  enableError={this.state.disabledChange!=true && this.state.carList[rowData].provCom!=undefined && isNaN(parseInt(this.state.carList[rowData].provCom.replace(this.state.money.symbole,''))) } placeholder={"ex : "+((this.state.money.position=="left")?(this.state.money.symbole+" "):"")+"2"+((this.state.money.position=="right")?(this.state.money.symbole):"")} onChangeText={(text)=>{this.changePrice(rowData,text,"provCom")}}/>}

                   <View style={{flexDirection:"row", alignItems:"center", justifyContent:"center"}}>
                          {this.state.carListSave[rowData]!=undefined && <MavMiniButton color={"orange"}  maximize={true} icon={(style.mode=="dark")?require('../assets/back_black.png'):require('../assets/back_white.png')} text={strings.cancel} onlyButton={true}  onPress={()=>{ this['viewCar_' + i].close(); var opt=this.state.carList; opt[rowData]=JSON.parse(JSON.stringify(this.state.carListSave[rowData])); this.setState({carList:opt})     }} />}
                          <MavMiniButton style={{marginLeft:(this.state.carListSave[rowData]!=undefined)?12:undefined, marginRight:12}} color={style.colorValidate} maximize={true} icon={(style.mode=="dark")?require('../assets/checkBasic_black.png'):require('../assets/checkBasic_white.png')} text={strings.validate} onlyButton={true}  onPress={()=>{ this['viewCar_' + i].close();  var opt=this.state.carListSave; opt[rowData]=JSON.parse(JSON.stringify(this.state.carList[rowData])); this.setState({carList:opt})  }} />
                          <MavMiniButton color={style.colorNotification} maximize={true} icon={(style.mode=="dark")?require('../assets/close_black.png'):require('../assets/close_white.png')} text={strings.remove} onlyButton={true}  onPress={()=>{ this.removePrice(rowData,i);  }} />
                    </View>

            </TextPresentation>

          ))}


        {Object.keys(this.state.carList).length<7 && <View style={{alignItems:"center",justifyContent:"center", marginTop:30}}>
            <MavButton text={strings.add} bottomText={strings.vehiculeOne} onlyButton={true} onPress={()=>{var opt=JSON.parse(JSON.stringify(this.state.carList)); var nb=Object.keys(this.state.carList).length+1; opt["type"+nb]={passagers:1,}; this.setState({carList:opt,},() =>{var op=Object.keys(this.state.carList).length-1; this['viewCar_' +op].open(); })    }}/>
        </View>}



       <TextPresentation reduceTextSizeOnOff={true} editable={false} text={strings.otherProvisionZone}  icon={(style.mode=="dark")?require('../assets/clock_white.png'):require('../assets/clock_black.png')} style={{marginTop:20}} textMini={strings.otherProvisionZoneMoreInfo} elementRight={ 
        <TouchableHighlight underlayColor={'#FFFFFF00'} onPress={() => {  var typeZone=JSON.parse(JSON.stringify(this.state.typeZone)); console.log(typeZone); typeZone.push({name:""}); this.setState({typeZone:typeZone})  }} >
            <Image source={(style.mode=="light")?require('../assets/plus_black.png'):require('../assets/plus_white.png')} style={{height:30,width:30,resizeMode:"contain", }}/> 
        </TouchableHighlight>} 
        />



        {this.state.typeZone.map((rowDataT,indexR) => (
               <View style={{marginLeft:'5%', marginRight:'5%',marginTop:40,}} > 
                  <RaceTrajetInfo mode={"pricing"} colorStart={style.color1} disableEnd={true} colorEnd={style.color1} selectedZoneStartAction={(data) => { this.changeRadius(indexR)}} onPricePlaceFrom={(data) => { this.onPricePlace(data,indexR)}} selectedZoneStart={{type:"radius", value:(rowDataT.radius!=undefined)?rowDataT.radius:"" } } racePlaceStartName={(rowDataT.name=="")?strings.selectFrom:(strings.from+" : "+rowDataT.name)} disable={false} /> 
                  
                  {this.state.extraEUMode===true  && <TextPresentation style={{marginTop:5,marginLeft:15, marginRight:15}} keyboardType={"numeric"} editable={false} money={(rowDataT.money!=undefined)?rowDataT.money:this.state.money} text={(rowDataT.money!=undefined)?rowDataT.money[strings.idLangue]:this.state.money[strings.idLangue]} chooseMoney={true} flagMoney={(rowDataT.money!=undefined)?rowDataT.money.flag:this.state.money.flag} textExplication={strings.moneySelected} onChangeMoney ={(info)=>{ this.changeAllPrice(info,indexR); }}  />}


                  {(rowDataT.price!=undefined) && Object.keys(rowDataT.price).map((rowData,i) => (
                       <TextPresentation explicationChild={strings.priceProvisionAddExplication} ref={viewCar => {this['viewCar_'+indexR+"_" + i] = viewCar;}} style={{marginLeft:15, marginRight:15}} text={(rowDataT.price[rowData].name==undefined)? strings.newCar :((rowDataT.price[rowData].name!="")?rowDataT.price[rowData].name:strings.noNameCar)} disabledText={true} onOpen={(text)=>{ this.closeOtherViewMore(i,indexR ) }}  >

                         <TextPresentation enableError={this.state.disabledChange!=true && rowDataT.price[rowData].name==""} enableValidate={this.state.disabledChange!=true && rowDataT.price[rowData].name!=undefined && rowDataT.price[rowData].name.length>2 }  editable={!this.state.disabledChange} style={{marginTop:5}} text={(rowDataT.price[rowData].name!=undefined)?rowDataT.price[rowData].name:""} textExplication={strings.priceCarName} placeholder={"ex : Berline"} onChangeText={(text)=>{text=text.replace(/[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/gi, '');  var car=JSON.parse(JSON.stringify(this.state.typeZone));car[indexR].price[rowData].name=text; this.setState({typeZone:car}) ;}}/>
                         <TextPresentation reduceTextSizeOnOff={true} editable={false} selectedQuantity={(rowDataT.price[rowData].passagers==undefined)?1:rowDataT.price[rowData].passagers} text={strings.morePassager+" "+strings.max.toLowerCase()} enableValidate={this.state.disabledChange!=true && rowDataT.price[rowData].passagers!=undefined && rowDataT.price[rowData].passagers>1}  enableQuestion={this.state.disabledChange!=true && (rowDataT.price[rowData].passagers==undefined || rowDataT.price[rowData].passagers==1 || rowDataT.price[rowData].passagers==0)} onQuestion={(value)=>{this.alert.onAlert({title:strings.warningOnePassager}) }} onChangeQuantity={(value)=>{if(this.state.disabledChange!=true){  this.changePassagers(rowData, value, indexR) } }} />
                         {(this.state.luggageOption==true) && <TextPresentation reduceTextSizeOnOff={true}  editable={false} selectedQuantity={(rowDataT.price[rowData].luggageMax==undefined)?"1":rowDataT.price[rowData].luggageMax} text={strings.baggageMax} enableValidate={this.state.disabledChange!=true}  onChangeQuantity={(value)=>{ if(this.state.disabledChange!=true){  this.changeBaggage(rowData, value, indexR) } }} />}
                         {(this.state.co2onBill==true) && <TextPresentation reduceTextSizeOnOff={true}  text={(rowDataT.price[rowData].co2!=undefined)?rowDataT.price[rowData].co2.toString():""} textExplication={strings.co2+" g/km"} enableValidate={this.state.disabledChange!=true && !isNaN(parseInt(rowDataT.price[rowData].co2))}  enableError={this.state.disabledChange!=true && rowDataT.price[rowData].co2!=undefined && rowDataT.price[rowData].co2!="" && isNaN(parseInt(rowDataT.price[rowData].co2)) } placeholder={"ex : 115 g/km"} onChangeText={(text)=>{this.changeCO2(rowData,text, indexR)}}/>}



                        <TextPresentation editable={!this.state.disabledChange} keyboardType={"numeric"} text={(rowDataT.price[rowData][1]!=undefined)?rowDataT.price[rowData][1]:""} textExplication={strings.hour+" n°1 : "} enableValidate={this.state.disabledChange!=true && rowDataT.price[rowData][1]!=undefined && !isNaN(parseInt(rowDataT.price[rowData][1].replace(((rowDataT.money!=undefined)?rowDataT.money:this.state.money).symbole,'')))}  enableError={this.state.disabledChange!=true && rowDataT.price[rowData][1]!=undefined && isNaN(parseInt(rowDataT.price[rowData][1].replace(((rowDataT.money!=undefined)?rowDataT.money:this.state.money).symbole,''))) }  placeholder={"ex : "+((((rowDataT.money!=undefined)?rowDataT.money:this.state.money).position=="left")?(((rowDataT.money!=undefined)?rowDataT.money:this.state.money).symbole+" "):"")+"20"+((((rowDataT.money!=undefined)?rowDataT.money:this.state.money).position=="right")?(((rowDataT.money!=undefined)?rowDataT.money:this.state.money).symbole):"")} onChangeText={(text)=>{this.changePrice(rowData, text,"1", indexR)}}/>

                        <TextPresentation editable={!this.state.disabledChange} keyboardType={"numeric"} text={(rowDataT.price[rowData][2]!=undefined)?rowDataT.price[rowData][2]:""} textExplication={strings.hour+" n°2 : "} enableValidate={this.state.disabledChange!=true && rowDataT.price[rowData][2]!=undefined && !isNaN(parseInt(rowDataT.price[rowData][2].replace(((rowDataT.money!=undefined)?rowDataT.money:this.state.money).symbole,'')))}  enableError={this.state.disabledChange!=true && rowDataT.price[rowData][1]!=undefined && isNaN(parseInt(rowDataT.price[rowData][2].replace(((rowDataT.money!=undefined)?rowDataT.money:this.state.money).symbole,''))) }  placeholder={"ex : "+((((rowDataT.money!=undefined)?rowDataT.money:this.state.money).position=="left")?(((rowDataT.money!=undefined)?rowDataT.money:this.state.money).symbole+" "):"")+"20"+((((rowDataT.money!=undefined)?rowDataT.money:this.state.money).position=="right")?(((rowDataT.money!=undefined)?rowDataT.money:this.state.money).symbole):"")} onChangeText={(text)=>{this.changePrice(rowData, text,"2", indexR)}}/>
                        <TextPresentation editable={!this.state.disabledChange} keyboardType={"numeric"} text={(rowDataT.price[rowData][3]!=undefined)?rowDataT.price[rowData][3]:""} textExplication={strings.hour+" n°3 : "} enableValidate={this.state.disabledChange!=true && rowDataT.price[rowData][3]!=undefined && !isNaN(parseInt(rowDataT.price[rowData][3].replace(((rowDataT.money!=undefined)?rowDataT.money:this.state.money).symbole,'')))}  enableError={this.state.disabledChange!=true && rowDataT.price[rowData][1]!=undefined && isNaN(parseInt(rowDataT.price[rowData][3].replace(((rowDataT.money!=undefined)?rowDataT.money:this.state.money).symbole,''))) }  placeholder={"ex : "+((((rowDataT.money!=undefined)?rowDataT.money:this.state.money).position=="left")?(((rowDataT.money!=undefined)?rowDataT.money:this.state.money).symbole+" "):"")+"20"+((((rowDataT.money!=undefined)?rowDataT.money:this.state.money).position=="right")?(((rowDataT.money!=undefined)?rowDataT.money:this.state.money).symbole):"")} onChangeText={(text)=>{this.changePrice(rowData, text,"3", indexR)}}/>
                        <TextPresentation editable={!this.state.disabledChange} keyboardType={"numeric"} text={(rowDataT.price[rowData][4]!=undefined)?rowDataT.price[rowData][4]:""} textExplication={strings.hour+" n°4 : "} enableValidate={this.state.disabledChange!=true && rowDataT.price[rowData][4]!=undefined && !isNaN(parseInt(rowDataT.price[rowData][4].replace(((rowDataT.money!=undefined)?rowDataT.money:this.state.money).symbole,'')))}  enableError={this.state.disabledChange!=true && rowDataT.price[rowData][1]!=undefined && isNaN(parseInt(rowDataT.price[rowData][4].replace(((rowDataT.money!=undefined)?rowDataT.money:this.state.money).symbole,''))) }  placeholder={"ex : "+((((rowDataT.money!=undefined)?rowDataT.money:this.state.money).position=="left")?(((rowDataT.money!=undefined)?rowDataT.money:this.state.money).symbole+" "):"")+"20"+((((rowDataT.money!=undefined)?rowDataT.money:this.state.money).position=="right")?(((rowDataT.money!=undefined)?rowDataT.money:this.state.money).symbole):"")} onChangeText={(text)=>{this.changePrice(rowData, text,"4", indexR)}}/>
                        <TextPresentation editable={!this.state.disabledChange} keyboardType={"numeric"} text={(rowDataT.price[rowData][5]!=undefined)?rowDataT.price[rowData][5]:""} textExplication={strings.hour+" n°5 : "} enableValidate={this.state.disabledChange!=true && rowDataT.price[rowData][5]!=undefined && !isNaN(parseInt(rowDataT.price[rowData][5].replace(((rowDataT.money!=undefined)?rowDataT.money:this.state.money).symbole,'')))}  enableError={this.state.disabledChange!=true && rowDataT.price[rowData][1]!=undefined && isNaN(parseInt(rowDataT.price[rowData][5].replace(((rowDataT.money!=undefined)?rowDataT.money:this.state.money).symbole,''))) }  placeholder={"ex : "+((((rowDataT.money!=undefined)?rowDataT.money:this.state.money).position=="left")?(((rowDataT.money!=undefined)?rowDataT.money:this.state.money).symbole+" "):"")+"20"+((((rowDataT.money!=undefined)?rowDataT.money:this.state.money).position=="right")?(((rowDataT.money!=undefined)?rowDataT.money:this.state.money).symbole):"")} onChangeText={(text)=>{this.changePrice(rowData, text,"5", indexR)}}/>
                        <TextPresentation editable={!this.state.disabledChange} keyboardType={"numeric"} text={(rowDataT.price[rowData].more!=undefined)?rowDataT.price[rowData].more:""} textExplication={strings.hourMore} enableValidate={this.state.disabledChange!=true && rowDataT.price[rowData].more!=undefined && !isNaN(parseInt(rowDataT.price[rowData].more.replace(((rowDataT.money!=undefined)?rowDataT.money:this.state.money).symbole,'')))}  enableError={this.state.disabledChange!=true && rowDataT.price[rowData].more!=undefined && isNaN(parseInt(rowDataT.price[rowData].more.replace(((rowDataT.money!=undefined)?rowDataT.money:this.state.money).symbole,''))) }  placeholder={"ex : "+((((rowDataT.money!=undefined)?rowDataT.money:this.state.money).position=="left")?(((rowDataT.money!=undefined)?rowDataT.money:this.state.money).symbole+" "):"")+"20"+((((rowDataT.money!=undefined)?rowDataT.money:this.state.money).position=="right")?(((rowDataT.money!=undefined)?rowDataT.money:this.state.money).symbole):"")} onChangeText={(text)=>{this.changePrice(rowData, text,"more", indexR)}}/>

                         {(this.state.vipMode===true) && <TextPresentation  textRight={strings.modify} forceClick={()=>{ this.viewTarget(rowData, indexR) }} onTextRightClick={()=>{ this.viewTarget(rowData, indexR) }}  text={(rowDataT.price[rowData].onlyAdmin==true)?(strings.onlyAdmin+"\n"): ((rowDataT.price[rowData].target==undefined || (rowDataT.price[rowData].target.standard==true && rowDataT.price[rowData].target.vip==true && rowDataT.price[rowData].target.pro==true))?(strings.all+"\n"):( ((rowDataT.price[rowData].target.standard==true)?(strings.standard+"\n"):"")+((rowDataT.price[rowData].target.vip==true)?(strings.vip+"\n"):"")+((rowDataT.price[rowData].target.pro==true)?(strings.pro+"\n"):"")  ))}  textExplication={strings.target} textExplicationSmall={strings.selectUsersOption} editable={false} />}



                        {(this.state.providerFixeCommission==true) && <TextPresentation keyboardType={"numeric"} text={(rowDataT.price[rowData].provCom!=undefined)?rowDataT.price[rowData].provCom:""}  textExplication={strings.providerCommission} enableValidate={this.state.disabledChange!=true && rowDataT.price[rowData].provCom!=undefined && !isNaN(parseInt(rowDataT.price[rowData].provCom.replace(((rowDataT.money!=undefined)?rowDataT.money:this.state.money).symbole,'')))}  enableError={this.state.disabledChange!=true && rowDataT.price[rowData].provCom!=undefined && isNaN(parseInt(rowDataT.price[rowData].provCom.replace(((rowDataT.money!=undefined)?rowDataT.money:this.state.money).symbole,''))) } placeholder={"ex : "+((((rowDataT.money!=undefined)?rowDataT.money:this.state.money).position=="left")?(((rowDataT.money!=undefined)?rowDataT.money:this.state.money).symbole+" "):"")+"2"+((((rowDataT.money!=undefined)?rowDataT.money:this.state.money).position=="right")?(((rowDataT.money!=undefined)?rowDataT.money:this.state.money).symbole):"")} onChangeText={(text)=>{this.changePrice(rowData,text,"provCom", indexR)}}/>}


                        <View style={{flexDirection:"row", alignItems:"center", justifyContent:"center"}}>
                                {this.state.typeZoneSave[indexR].price!=undefined && this.state.typeZoneSave[indexR].price[rowData]!=undefined && <MavMiniButton color={"orange"}  maximize={true} icon={(style.mode=="dark")?require('../assets/back_black.png'):require('../assets/back_white.png')} text={strings.cancel} onlyButton={true}  onPress={()=>{ this['viewCar_'+indexR+"_" + i].close(); var opt=this.state.typeZone; opt[indexR].price[rowData]=JSON.parse(JSON.stringify(this.state.typeZoneSave[indexR].price[rowData])); this.setState({typeZone:opt})     }} />}
                                <MavMiniButton style={{marginLeft:(this.state.typeZoneSave[rowData]!=undefined)?12:undefined, marginRight:12}} color={style.colorValidate} maximize={true} icon={(style.mode=="dark")?require('../assets/checkBasic_black.png'):require('../assets/checkBasic_white.png')} text={strings.validate} onlyButton={true}  onPress={()=>{ this['viewCar_'+indexR+"_" + i].close();  var opt=this.state.typeZoneSave; opt[rowData]=JSON.parse(JSON.stringify(this.state.typeZone[indexR].price[rowData])); this.setState({typeZone:opt})  }} />
                                <MavMiniButton color={style.colorNotification} maximize={true} icon={(style.mode=="dark")?require('../assets/close_black.png'):require('../assets/close_white.png')} text={strings.remove} onlyButton={true}  onPress={()=>{ this.removePrice(rowData,i, indexR);  }} />
                          </View>


                        </TextPresentation>

                    ))}

                    {(rowDataT.price==undefined || Object.keys(rowDataT.price).length<7) && 
                      <View style={{alignItems:"center",justifyContent:"center", marginTop:15}}>
                        <MavButton text={strings.add} bottomText={strings.vehiculeOne} onlyButton={true} onPress={()=>{var opt=JSON.parse(JSON.stringify(this.state.typeZone)); if(opt[indexR].price==undefined) opt[indexR].price={}; var nb=Object.keys(opt[indexR].price).length+1; opt[indexR].price["type"+nb]={passagers:1,}; this.setState({typeZone:opt,},() =>{var op=Object.keys(this.state.typeZone[indexR].price).length-1; this['viewCar_'+indexR+"_" + op].open(); })    }}/>
                        <MavButton text={strings.remove} bottomText={strings.thisZone} strokeMode={true} style={{marginTop:5}} onlyButton={true} onPress={()=>{ var typeZone=JSON.parse(JSON.stringify(this.state.typeZone)); typeZone=typeZone.slice(0,indexR).concat(typeZone.slice(indexR+1,typeZone.length)); this.setState({typeZone:typeZone})   }}/>

                    </View>}





                </View>
          ))}




        <TextPresentation reduceTextSizeOnOff={true} editable={false} text={strings.settingsOther}  icon={(style.mode=="dark")?require('../assets/etc_white.png'):require('../assets/etc_black.png')} style={{marginTop:10}}  />




        <TextPresentation reduceTextSizeOnOff={true} editable={false} selectedQuantity={this.state.durationMin} text={strings.durationMinimumMinutes} textMini={strings.durationInMinute} onChangeQuantity={(value)=>{
          if(this.state.disabledChange!=true){   var tt=this.state.durationMin;
                tt+=(value==1)?30:-30;
                if(tt<0) tt=0;
                this.setState({durationMin:tt}) 

          }}} />


         <TextPresentation keyboardType={"numeric"} text={this.state.kilometerMax} textExplication={strings.kmMaxHour} placeholder={"30km"} onChangeText={(text)=>{this.changeKm(text)}}/>

         <TextPresentation reduceTextSizeOnOff={true} editable={false} onoff={this.state.multipleCarProvision} text={strings.multipleCarProvision} textMini={strings.multipleCarProvisionMoreInfo}  onOnOff={()=>{ this.setState({multipleCarProvision:(this.state.multipleCarProvision==true)?false:true}) }}/>


      <View style={{alignItems:"center",justifyContent:"center", marginTop:20,marginBottom:30}}>

        <MavButton text={strings.confirm} onlyButton={true} onPress={()=>{ this.confirmModification()}}/>

        </View>






        
        
        
        
        
        <MavAlert ref={alert => {this.alert = alert;}}/>

      </ScrollView>
      }</StyleContext.Consumer>
    );
  }
}

account.navigationOptions = ({ navigation, screenProps }) => {
  return {
    headerTitle: strings.provision,
    headerTintColor: screenProps.headerColor,
    headerStyle: {
      backgroundColor: screenProps.headerBackgroundColor,
    },
  };
};

export function generateUUID() {
  function s4() {
    return Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1);
  }
  return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
    s4() + '-' + s4() + s4() + s4();
}

